<a class="supplierCodeLink" (click)="onClick($event)" style="cursor: pointer;">
    {{params.value}}
</a>